module.exports = __webpack_public_path__ + "static/media/map_sepia.85b8b5e7.png";